module.exports = __webpack_public_path__ + "static/media/poweredby.be7a0802.svg";